/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { BadgeDirective } from '@ng-falcon/badge/badge.directive';
import {
  TESTER_NAVIGATION_HEADER_SERVICE,
  TesterNavigationHeaderService,
} from '../tester-navigation-header.service';

@Component({
    selector: 'ngf-tester-navigation-header-chat',
    templateUrl: './tester-navigation-header-chat.component.html',
    styleUrls: ['./tester-navigation-header-chat.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [BadgeDirective]
})
export class TesterNavigationHeaderChatComponent implements OnInit {
  chatUrl: string | null = null;
  unreadCount = 0;
  hasUnreadMessages = false;

  get displayCount(): number | string {
    return this.unreadCount > 9 ? '9+' : this.unreadCount;
  }

  get ariaLabel(): string {
    if (!this.hasUnreadMessages) {
      return 'Chat';
    }
    if (this.unreadCount > 0) {
      return `Chat, you have unread messages, ${this.unreadCount} in which you are tagged`;
    }
    return 'Chat, you have unread messages';
  }

  constructor(
    @Inject(TESTER_NAVIGATION_HEADER_SERVICE) private navHeaderService: TesterNavigationHeaderService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.navHeaderService.getChatUrl().then((url) => {
      this.chatUrl = url;
      this.cdr.markForCheck();
    });

    this.navHeaderService.getUnreadMessages().then((messages) => {
      this.hasUnreadMessages = messages.hasUnread;
      this.unreadCount = messages.count;
      this.cdr.markForCheck();
    });
  }
}
